import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon/Interface/10x10/chevron down",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Polygon 1",
			d: "M5.36029 7.62558C5.16359 7.82999 4.83641 7.82999 4.63971 7.62558L1.4846 4.34669C1.17894 4.02904 1.40406 3.5 1.84489 3.5L8.15511 3.5C8.59594 3.5 8.82106 4.02904 8.5154 4.34669L5.36029 7.62558Z",
			fill: "#E5A500"
		})
	})
});
export default SvgDropdown;
